import { useEffect, useState } from 'react';

const useTimeZone = () => {
  const [isFromAmerica, setIsFromAmerica] = useState<boolean>(true);
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

  useEffect(() => {
    if (!timeZone.toLocaleLowerCase().startsWith('america')) {
      setIsFromAmerica(false);
    } else {
      setIsFromAmerica(true);
    }
  }, [timeZone]);

  return [isFromAmerica];
};

export default useTimeZone;
